export default __webpack_public_path__ + "static/media/SVGDatabase.0ebbb22a.svg";